import { connect } from 'react-redux';
import { getDeviationPatchedWithStoreState } from '../../../../CollectionPanel/redux/selectors';
import { changeFaveCustom } from '../../../../CollectionPanel/redux/actionCreators';
const mapStateToProps = (state, { deviation })=>{
    const patchedDeviation = getDeviationPatchedWithStoreState(state, deviation);
    return {
        deviation: patchedDeviation
    };
};
const mapDispatchToProps = {
    onChangeFave: changeFaveCustom
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=FavouriteButton.container.js.map